export const ContentActionTypes = {
  GetContent: 'CONTENT_GET_CONTENT',
  GetContentSuccess: 'CONTENT_GET_CONTENT_SUCCESS',
  GetContentError: 'CONTENT_GET_CONTENT_ERROR',
  SetPagination: 'CONTENT_SET_PAGINATION',
  ToggleEntry: 'CONTENT_TOGGLE_ENTRY',
  ToggleAllEntries: 'CONTENT_TOGGLE_ALL_ENTRIES',
  SetSelectedEntries: 'CONTENT_SET_SELECTED_ENTRIES',
  ClearSelectedEntries: 'CONTENT_CLEAR_SELECTED_ENTRIES',
  AddToQueue: 'CONTENT_ADD_TO_QUEUE',
  AddToQueueSuccess: 'CONTENT_ADD_TO_QUEUE_SUCCESS',
  AddToQueueError: 'CONTENT_ADD_TO_QUEUE_ERROR',
  SendForTranslation: 'CONTENT_SEND_FOR_TRANSLATION',
  SendForTranslationSuccess: 'CONTENT_SEND_FOR_TRANSLATION_SUCCESS',
  SendForTranslationError: 'CONTENT_SEND_FOR_TRANSLATION_ERROR',
  GetContentTypes: 'GET_CONTENT_TYPES',
  GetContentTypesError: 'GET_CONTENT_TYPES_ERROR',
  GetContentTypesSuccess: 'GET_CONTENT_TYPES_SUCCESS',
  GetContentElements: 'GET_CONTENT_ELEMENTS',
  GetContentElementsError: 'GET_CONTENT_ELEMENTS_ERROR',
  GetContentElementsSuccess: 'GET_CONTENT_ELEMENTS_SUCCESS',
  GetWorkflowSteps: 'GET_WORKFLOW_STEPS',
  GetWorkflowStepsError: 'GET_WORKFLOW_STEPS_ERROR',
  GetWorkflowStepsSuccess: 'GET_WORKFLOW_STEPS_SUCCESS',
  GetTaxonomy: 'GET_TAXONOMY',
  GetTaxonomySuccess: 'GET_TAXONOMY_SUCCESS',
  GetTaxonomyError: 'GET_TAXONOMY_ERROR',
};
